import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { CompanyOverview } from '../model/company-overview';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class CompaniesOverviewControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => {
    const result: ProperPageResult<CompanyOverview> = new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;
    return result;
  };

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/companies/overview', requestServices);
  }

  public companiesOverview(
    filters: string,
    sortProperty: string,
    sortAscending: boolean,
    page: number,
    pageSize: number,
    showArchived: boolean
  ): Promise<ProperPageResult<CompanyOverview>> {
    const filtersParam = `filters=${filters}`;
    const sortParam = `${sortProperty},${sortAscending ? 'asc' : 'desc'}`;
    const pageableParam: string = `page=${page}&size=${pageSize}&sort=${sortParam}`;
    const showArchivedParam: string = `showArchived=${showArchived}`;
    const pathParams: string = `?${filtersParam}&${pageableParam}&${showArchivedParam}`;

    return this.get(pathParams, this.deserialize).toPromise();
  }
}
